/** Copy for Black Key private note / Black Key Access welcome-pack page. */
export const BLACK_KEY_ACCESS_CONTENT = {
  title: 'BLACK KEY ACCESS',
  summary:
    'Black Key Access is granted selectively to a limited number of Reserve members. It reflects the highest level of access and recognition within the Axonall Reserve circle.',
  reflects: {
    heading: 'What it reflects',
    bullets: [
      'A deeper level of trust and alignment within the Reserve circle',
      'Recognition for members whose presence, professionalism, and contribution stand apart',
      'A more private level of access within Axonall Reserve',
    ],
  },
  regarded: {
    heading: 'How it is regarded',
    bullets: [
      'This is the most elevated level of access within Reserve',
      'Intentionally selective and not widely extended',
      'A mark of confidence, closeness, and distinction inside the circle',
    ],
  },
}
